module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-ocuppancy pa-1 mb-3"
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-0": "",
      "mb-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "disabled": !_vm.dateStart,
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.getOccupation
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": "",
      "md-2": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.deactived
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "align-center": "",
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "label": "qp Hotels Lima",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.getOccupation
    },
    model: {
      value: (_vm.idSubsidiary),
      callback: function($$v) {
        _vm.idSubsidiary = $$v
      },
      expression: "idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('section', {
    staticClass: "filters-by-time row wrap"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'activeBtn': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.onDateFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t")])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-usage row wrap",
    attrs: {
      "to": {
        name: 'report-occupancy'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/pie-chart-outline.svg",
      "alt": "",
      "height": "25px",
      "width": "25px"
    }
  })])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-6": "",
      "md-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.customButtons
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\tImprimir Reporte\n\t\t\t\t")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs"
  }, [_c('v-tabs-items', [_c('table', [_c('tr', _vm._l((_vm.occupation), function(item, indexOcu) {
    return _c('th', {
      key: indexOcu
    }, [_vm._v(_vm._s(item.name)), _c('br'), _vm._v(" "), _c('span', {
      class: {
        'colorGreen': (0 < item.percent && item.percent <= 49), 'colorYellow': (50 <= item.percent && item.percent <= 79), 'colorRed': (80 <= item.percent && item.percent <= 100)
      }
    }, [_vm._v(_vm._s(item.percent) + " "), (item.percent) ? _c('span', [_vm._v("%")]) : _vm._e()])])
  })), _vm._v(" "), _vm._l((_vm.occupationBody), function(occupationTable, indexBody) {
    return _c('tr', {
      key: indexBody,
      on: {
        "actions": _vm.customButtons
      }
    }, [_c('td', [_vm._v(_vm._s(occupationTable.date))]), _vm._v(" "), _vm._l((occupationTable.roomTypes), function(typeRoom, indexRoomType) {
      return _c('td', {
        key: indexRoomType
      }, [_vm._v(_vm._s(typeRoom.value))])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(occupationTable.occupied))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(occupationTable.free))]), _vm._v(" "), _c('td', {
      class: {
        'colorGreen': (0 < occupationTable.percent && occupationTable.percent <= 49), 'colorYellow': (50 <= occupationTable.percent && occupationTable.percent <= 79), 'colorRed': (80 <= occupationTable.percent && occupationTable.percent <= 100)
      }
    }, [_vm._v(_vm._s(occupationTable.percent))])], 2)
  })], 2)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ea1f2ff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/reports/Occupancy-new.vue
// module id = 1581
// module chunks = 55